export async function updatePersonalInfo(personalInfoRepository, personalInfo) {
  return personalInfoRepository.update(personalInfo)
}